import { useSelector } from "react-redux";
import { AppStore } from "../../redux/store";

const SuccessPay = () => {
 const { country } = useSelector((store: AppStore) => store.country);
  const GoToMarket = () => {
    
    // do something
    if (typeof window !== "undefined") {
      window.open(
        `/${country}/venta/casas-y-apartamentos/proyectos`,
        "_self"
      );
    }
  };

  
    return (
    <section className="h-screen flex justify-center items-center bg-[#D5F0E3]">
        <div className="container mx-auto">
    <div className=" max-w-2xl mx-auto w-full lg:px-0 py-10">
        <img className=" w-48 mx-auto" src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg" alt="" />
        <h1 className=" text-center text-[#212121] text-3xl font-semibold mt-4">Tú pago fue realizado con éxito</h1>
        <p className=" text-center font-medium text-[#757575] ">Por si estas interesado en otros proyectos, visita nuestra marketplace</p>
        <button onClick={GoToMarket} className=" py-2 px-6 bg-[#212121] text-center font-medium rounded-xl text-white mx-auto block mt-6 font-medium">
            Ver más proyectos
        </button>
    </div>
    </div>
    </section>
    )
}
export default SuccessPay;